/**
 * Renders a custom-styled checkbox and a hidden input and reacts to user input
 */

import React from 'react';

const Checkbox = class Checkbox extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * handleChange - Handles select/deselect of a checkbox using the provided function
   */
  handleChange(e) {
    const { onChange } = this.props;

    if (onChange) {
      onChange(e);
    }
  }

  render() {
    const { className, defaultChecked, hideLabel, id, label, value } = this.props;

    return (
      <div className={`cbox ${className ? className : ''}`}>
        <input
          id={id}
          className="cbox__input"
          type="checkbox"
          value={value || true}
          defaultChecked={defaultChecked ? true : false}
          onChange={(e) => this.handleChange(e)}
        />

        <label
          className={`cbox__lbl ${hideLabel ? 'cbox__lbl--alt' : ''}`}
          htmlFor={id}
        >
          {hideLabel &&
            <span className="meta">{label}</span>
          }

          {!hideLabel &&
            label
          }
        </label>
      </div>
    )
  }
}

export default Checkbox;